import * as _ from 'lodash';

export default class Search {
    static generateSearchOptions(items, text, value): any {
        return items.map((item => {
            return {
                text: item[text],
                value: item[value]
            };
        }));
    }

    static generateSearchGroupOptions(items, text, value, groupBy): any {
        const searchGroupOptions = [];
        items.forEach(item => {
          searchGroupOptions.push({
            name: item[groupBy],
            text: item[text],
            value: item[value]
          });
        });
        return searchGroupOptions;
    }

  static getOptionValue(items): any {
    return (value) => {
      if (Array.isArray(value)) {
        const filteredItems = _.filter(items, item => value.indexOf(item.value) > -1);
        const filteredItemsValue = filteredItems.map(filteredItem => filteredItem.text);

        return filteredItemsValue.toString();
      }
      return items.find(item => item.value === value).text;
    };
  }
}
